import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-slate-50/80 p-4" }
const _hoisted_4 = { class: "relative min-w-[280px] flex-1" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "min-w-full divide-y divide-slate-200 text-sm" }
const _hoisted_8 = { class: "bg-slate-100 text-left text-sm font-bold uppercase text-slate-600" }
const _hoisted_9 = { class: "w-12 px-4 py-3.5" }
const _hoisted_10 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_11 = { class: "transition hover:bg-teal-50/45" }
const _hoisted_12 = { class: "px-4 py-3.5" }
const _hoisted_13 = { class: "px-4 py-3.5" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "px-4 py-3.5 font-semibold text-slate-800" }
const _hoisted_16 = { class: "px-4 py-3.5 text-slate-600" }
const _hoisted_17 = { class: "px-4 py-3.5" }
const _hoisted_18 = { class: "flex flex-wrap gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "bg-slate-50/70"
}
const _hoisted_20 = {
  colspan: "5",
  class: "px-4 pb-5 pt-2"
}
const _hoisted_21 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white" }
const _hoisted_22 = { class: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3" }
const _hoisted_23 = { class: "overflow-x-auto" }
const _hoisted_24 = { class: "min-w-full divide-y divide-slate-200 text-sm" }
const _hoisted_25 = { class: "bg-slate-100 text-left text-sm font-bold uppercase text-slate-600" }
const _hoisted_26 = { class: "w-12 px-4 py-3" }
const _hoisted_27 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "px-4 py-3" }
const _hoisted_30 = { class: "px-4 py-3 font-medium text-slate-800" }
const _hoisted_31 = { class: "px-4 py-3" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "flex justify-end gap-2" }
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Quản lý nhóm và thành viên trong nhóm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
              _createVNode(_component_InputText, {
                modelValue: $setup.groupSearch,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.groupSearch) = $event)),
                class: "!pl-10",
                placeholder: "Tìm theo tên nhóm"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                label: "Xoá đã chọn",
                icon: "pi pi-trash",
                severity: "danger",
                outlined: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.deleteSelectedGroups())),
                loading: $setup.deletingGroups,
                disabled: $setup.selectedGroupIds.length < 1
              }, null, 8, ["loading", "disabled"]),
              _createVNode(_component_Button, {
                label: "Thêm nhóm",
                icon: "pi pi-plus-circle",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openAddGroupDialog()))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_9, [
                    _createVNode(_component_Checkbox, {
                      modelValue: $setup.isAllGroupsSelected,
                      binary: true,
                      "onUpdate:modelValue": $setup.toggleSelectAllGroups
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("th", { class: "w-12 px-4 py-3.5" }, null, -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-4 py-3.5" }, "Tên nhóm", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("th", { class: "px-4 py-3.5" }, "Số thành viên", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("th", { class: "px-4 py-3.5" }, "Thao tác", -1))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_10, [
                ($setup.filteredGroups.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.filteredGroups, (group) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.id
                      }, [
                        _createElementVNode("tr", _hoisted_11, [
                          _createElementVNode("td", _hoisted_12, [
                            _createVNode(_component_Checkbox, {
                              modelValue: $setup.isGroupSelected(group.id),
                              binary: true,
                              "onUpdate:modelValue": ($event: any) => ($setup.toggleSelectGroup(group.id))
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50",
                              onClick: ($event: any) => ($setup.toggleGroup(group))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["pi text-xs", 
                            $setup.isExpanded(group.id)
                              ? 'pi-chevron-down'
                              : 'pi-chevron-right'
                          ])
                              }, null, 2)
                            ], 8, _hoisted_14)
                          ]),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(group.groupName), 1),
                          _createElementVNode("td", _hoisted_16, _toDisplayString($setup.memberCount(group.id)), 1),
                          _createElementVNode("td", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_Button, {
                                label: "Thêm thành viên",
                                icon: "pi pi-user-plus",
                                onClick: ($event: any) => ($setup.openAddMemberDialog(group)),
                                class: "!min-h-[36px] px-3 py-1.5"
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_Button, {
                                label: "Xoá nhóm",
                                icon: "pi pi-trash",
                                severity: "danger",
                                onClick: ($event: any) => ($setup.deleteGroup(group.id)),
                                loading: $setup.deletingGroupId === group.id,
                                class: "!min-h-[36px] px-3 py-1.5"
                              }, null, 8, ["onClick", "loading"])
                            ])
                          ])
                        ]),
                        ($setup.isExpanded(group.id))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                              _createElementVNode("td", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "font-bold text-slate-800" }, " Thành viên trong nhóm ", -1)),
                                    _createVNode(_component_Button, {
                                      label: "Xoá đã chọn",
                                      icon: "pi pi-trash",
                                      severity: "danger",
                                      outlined: "",
                                      onClick: ($event: any) => ($setup.deleteSelectedMembers(group.id)),
                                      loading: $setup.deletingMembersGroupId === group.id,
                                      disabled: $setup.selectedMemberIds(group.id).length < 1,
                                      class: "!min-h-[36px] px-3 py-1.5"
                                    }, null, 8, ["onClick", "loading", "disabled"])
                                  ]),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("table", _hoisted_24, [
                                      _createElementVNode("thead", _hoisted_25, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", _hoisted_26, [
                                            _createVNode(_component_Checkbox, {
                                              modelValue: $setup.isAllMembersSelected(group.id),
                                              binary: true,
                                              "onUpdate:modelValue": ($event: any) => (
                                      $setup.toggleSelectAllMembers(group.id, $event)
                                    )
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _cache[19] || (_cache[19] = _createElementVNode("th", { class: "px-4 py-3" }, "Tên thành viên", -1)),
                                          _cache[20] || (_cache[20] = _createElementVNode("th", { class: "px-4 py-3" }, "Thao tác", -1))
                                        ])
                                      ]),
                                      _createElementVNode("tbody", _hoisted_27, [
                                        ($setup.loadingMembers[group.id])
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [...(_cache[21] || (_cache[21] = [
                                              _createElementVNode("td", {
                                                colspan: "4",
                                                class: "px-4 py-8 text-center font-medium text-slate-500"
                                              }, " Đang tải thành viên ", -1)
                                            ]))]))
                                          : ($setup.members(group.id).length)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.members(group.id), (member) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: member.id,
                                                  class: "transition hover:bg-teal-50/40"
                                                }, [
                                                  _createElementVNode("td", _hoisted_29, [
                                                    _createVNode(_component_Checkbox, {
                                                      modelValue: 
                                      $setup.isMemberSelected(group.id, member.id)
                                    ,
                                                      binary: true,
                                                      "onUpdate:modelValue": ($event: any) => (
                                      $setup.toggleSelectMember(group.id, member.id)
                                    )
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_30, _toDisplayString(member.zaloName), 1),
                                                  _createElementVNode("td", _hoisted_31, [
                                                    _createVNode(_component_Button, {
                                                      label: "Xoá",
                                                      icon: "pi pi-trash",
                                                      severity: "danger",
                                                      onClick: ($event: any) => ($setup.deleteMember(group.id, member.id)),
                                                      loading: $setup.deletingMemberId === member.id,
                                                      class: "!min-h-[34px] px-3 py-1.5"
                                                    }, null, 8, ["onClick", "loading"])
                                                  ])
                                                ]))
                                              }), 128))
                                            : (_openBlock(), _createElementBlock("tr", _hoisted_32, [...(_cache[22] || (_cache[22] = [
                                                _createElementVNode("td", {
                                                  colspan: "4",
                                                  class: "px-4 py-8 text-center font-medium text-slate-500"
                                                }, " Nhóm chưa có thành viên ", -1)
                                              ]))]))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_33, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("td", {
                        colspan: "5",
                        class: "px-4 py-10 text-center font-medium text-slate-500"
                      }, " Không có dữ liệu ", -1)
                    ]))]))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Dialog, {
          visible: $setup.isAddGroupDialogVisible,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.isAddGroupDialogVisible) = $event)),
          header: "Thêm nhóm",
          modal: "",
          style: { width: 'min(520px, calc(100vw - 32px))' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_Button, {
                label: "Huỷ",
                icon: "pi pi-times",
                severity: "secondary",
                outlined: "",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.closeAddGroupDialog())),
                disabled: $setup.addingGroup
              }, null, 8, ["disabled"]),
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.addGroup())),
                loading: $setup.addingGroup,
                disabled: !$setup.groupCreate.groupName
              }, null, 8, ["loading", "disabled"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { for: "groupname" }, "Tên nhóm", -1)),
              _createVNode(_component_InputText, {
                id: "groupname",
                modelValue: $setup.groupCreate.groupName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.groupCreate.groupName) = $event)),
                placeholder: "Nhập tên nhóm",
                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => ($setup.addGroup()), ["enter"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Dialog, {
          visible: $setup.isAddMemberDialogVisible,
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.isAddMemberDialogVisible) = $event)),
          header: `Thêm thành viên vào nhóm ${
          $setup.selectedGroupForMember?.groupName || ''
        }`,
          modal: "",
          style: { width: 'min(620px, calc(100vw - 32px))' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_Button, {
                label: "Huỷ",
                icon: "pi pi-times",
                severity: "secondary",
                outlined: "",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.closeAddMemberDialog())),
                disabled: $setup.addingMember
              }, null, 8, ["disabled"]),
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.addMember())),
                loading: $setup.addingMember,
                disabled: 
                !$setup.selectedGroupForMember || $setup.selectedCustomerIds.length < 1
              
              }, null, 8, ["loading", "disabled"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "memberselect" }, "Chọn thành viên", -1)),
              _createVNode(_component_MultiSelect, {
                id: "memberselect",
                modelValue: $setup.selectedCustomerIds,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectedCustomerIds) = $event)),
                options: $setup.listCustomer,
                optionLabel: "name",
                optionValue: "idMember",
                filter: true,
                placeholder: "Chọn thành viên"
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        _createVNode(_component_ConfirmDeleteModal, {
          modelValue: $setup.showConfirmModal,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.showConfirmModal) = $event)),
          title: $setup.confirmTitle,
          message: $setup.confirmMessage,
          "is-loading": $setup.isConfirming,
          onConfirm: $setup.confirmAction,
          onCancel: $setup.cancelAction
        }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
      ]),
      _: 1
    })
  ]))
}